const KEY = "zibuzz_config";

export const ConfigStorage = {
  save: (data) => {
    localStorage.setItem(KEY, JSON.stringify(data));
  },

  get: () => {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  },

  clear: () => {
    localStorage.removeItem(KEY);
  }
};
